import treeDehydrated from "@/assets/tree-dehydrated.jpg";
import treeHydrated from "@/assets/tree-hydrated.jpg";

export const BeforeAfter = () => {
  return (
    <section className="py-12 md:py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-cormorant text-4xl md:text-5xl font-bold text-foreground mb-3">
              The Difference Is Clear
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground font-inter font-light">
              See what Christmas Tree Food does
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-4 md:gap-6">
            {/* Without - Dehydrated */}
            <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
              <img 
                src={treeDehydrated} 
                alt="Dehydrated Christmas tree needles without nutrients" 
                className="w-full h-full object-cover"
                loading="lazy"
                width={408}
                height={306}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h3 className="font-cormorant text-xl md:text-2xl font-bold text-white mb-1">
                  Without Christmas Tree Food
                </h3>
                <p className="text-sm md:text-base text-white/90 font-inter leading-relaxed">
                  Dry, brittle needles. Dull color. Tree deteriorates within weeks.
                </p>
              </div>
            </div>
            
            {/* With - Hydrated */}
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] ring-2 ring-primary/30">
              <img 
                src={treeHydrated} 
                alt="Healthy hydrated Christmas tree needles with Christmas Tree Food" 
                className="w-full h-full object-cover"
                loading="lazy"
                width={404}
                height={303}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
              <h3 className="font-cormorant text-xl md:text-2xl font-bold text-white mb-1">
                  With Christmas Tree Food
                </h3>
                <p className="text-sm md:text-base text-white/90 font-inter leading-relaxed">
                  Flexible needles. Vibrant green. Trees that can last into January.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
